module.exports = "/img/_/_/_/assets/images/chase//10.png?28f720368808496b5928a5e4721868df";